<script context="module">
    import {doFetch} from '../lib/data.js';
    import {session} from '../Utilities/Session.svelte';

    export async function checkLoggedIn() {
        doFetch('/api/auth/login', {
            method: "GET"
        }).then(setUser).catch((response) => {});
    }

    export async function logOut() {
        doFetch('/api/auth/login',{
            method: "DELETE"
        }).then(
            session.set({
                loggedIn: false,
                user: ''
            })
        )
    }

    export async function setUser(response) {
        let result = await response.json();
        session.set({
            loggedIn: true,
            user: result.user
        });
    }

</script>
<script>
    import {onMount, tick} from 'svelte';
    import { NotificationDisplay, notifier } from '@beyonk/svelte-notifications'

    let show_duo = false;

    let user = {
        email: '',
        password: ''
    }

    function check_duo(response) {
      let sig_response = response.firstChild.value;

      doFetch('/api/auth/mfa', {
        method: "POST",
        body: JSON.stringify({
          sig: sig_response
        })
      }).then(setUser).catch(response => {
        if (response.status == 401) {
          show_duo = false;
          notifier.warning("MFA Failed")
        }
      })
    }

    async function show_mfa_prompt(response) {
      let data = await response.json()

      if (data.logged_in) {
        session.set({
            loggedIn: true,
            user: data.user
        });
        return
      }

      show_duo = true;
      await tick();

      Duo.init({
        host: data.api_url,
        sig_request: data.sig_request,
        submit_callback: check_duo
      })
    }

    async function logIn() {
        doFetch('/api/auth/login', {
            method: "POST",
            body: JSON.stringify(user)
        }).then(show_mfa_prompt).catch((response) => {
            if (response.status == 401) {
                notifier.warning("Invalid Credentials")
            }
        })
    }
</script>

<style>
  iframe {
    height: 350px;
  }
</style>

<section class="hero is-fullheight" style="background: #F2F6FA;">
  <NotificationDisplay />
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="column is-4 is-offset-4">
      {#if show_duo}
        <iframe id="duo_iframe" title="Duo"></iframe>
      {:else}
        <h3 class="title has-text-grey">Login</h3>
        <div class="box">
          <form on:submit|preventDefault={logIn}>

            <div class="field">
              <div class="control">
                <input name="email" type="email" class="input is-large" placeholder="Email Address" bind:value="{user.email}" required>
              </div>
            </div>

            <div class="field">
              <div class="control">
                  <input name="password" type="password" class="input is-large" placeholder="Password" bind:value="{user.password}" required>
              </div>
            </div>
            <button type="submit" class="button is-block is-info is-large" style="width: 100%" >Login</button>
          </form>
        </div>
        {/if}
      </div>
    </div>
  </div>
</section>